import React, { useState } from 'react';
import { FilterBar } from './FilterBar';
import { FilterModal } from './FilterModal';
import { ActiveFilter } from '../types/filters';
export function Header() {
  const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const handleRemoveFilter = (filterId: string) => {
    setActiveFilters(prev => prev.filter(f => f.filterId !== filterId));
  };
  const handleOpenFilters = () => {
    setIsFilterModalOpen(true);
  };
  const handleApplyFilters = (filters: ActiveFilter[]) => {
    setActiveFilters(filters);
  };
  return <>
      <header className="border-b border-gray-200 px-6 py-4 bg-white" data-id="element-418">
        <div className="flex items-center justify-between" data-id="element-419">
          <div className="flex-1" data-id="element-420" />
          <FilterBar activeFilters={activeFilters} onRemoveFilter={handleRemoveFilter} onOpenFilters={handleOpenFilters} data-id="element-421" />
        </div>
      </header>

      <FilterModal isOpen={isFilterModalOpen} onClose={() => setIsFilterModalOpen(false)} activeFilters={activeFilters} onApplyFilters={handleApplyFilters} data-id="element-422" />
    </>;
}